import { inject, Injectable } from '@angular/core';
import { DEFAULT_TIMEZONE } from '@constants/app.constants';
import { TimezoneDbModel } from '@models/timezone.model';
import { HttpClientService } from '@services/utils/http-client.service';
import momentTz from 'moment-timezone';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  private httpClientService = inject(HttpClientService);

  private _localTimezone: string | null = null;
  set localTimezone(timezone: string) {
    this._localTimezone = timezone;
  }
  get localTimezone(): string {
    return this._localTimezone;
  }

  getTimezones(): Observable<{ success: boolean, data: TimezoneDbModel[] }> {
    return this.httpClientService.get('timezones', {});
  }

  getLocalTimezone(): string {
    let tz: string | null = null;

    try {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      tz = null;
    }

    // If Intl fails or returns nonsense, fallback to moment.tz.guess()
    if (!tz || tz.startsWith("Etc/")) {
      tz = momentTz.tz.guess(true);
    }

    return tz || DEFAULT_TIMEZONE;
  }
}
